export default __webpack_public_path__ + "static/media/Correspondance.cca6e321.woff";